import { slice } from './slice';

const { reducer } = slice;

export * from './thunks';
export * as langSelectors from './selectors';

export default reducer;
